export default (type, payload, meta) => ({ type, payload, meta });
